import { setTuneCoreSuccessDialog } from 'app/store/Releases/slice';
import { ChakraConfirmationDialog } from 'app/components/Dialogs/ChakraConfirmationDialog';
import { useAppDispatch, useAppSelector } from 'app/store';
import { getTuneCoreSuccessDialog } from 'app/store/Releases/selectors';
import { useDisclosure } from '@chakra-ui/react';
import { useFetchTuneCoreUrl } from 'app/components/Releases/hooks/useFetchTuneCoreUrl';
import { openURL } from 'app/utils/utils';

export const TuneCoreExportSuccessDialog = () => {
  const dispatch = useAppDispatch();
  const tuneCoreSuccess = useAppSelector(getTuneCoreSuccessDialog);
  const { isOpen, onClose } = useDisclosure({
    isOpen: Boolean(tuneCoreSuccess),
  });

  const { fetchTuneCoreUrl, loading } = useFetchTuneCoreUrl(
    tuneCoreSuccess?.guid || ''
  );

  const handleTuneCoreRedirect = async () => {
    const url = await fetchTuneCoreUrl();
    if (url) {
      dispatch(setTuneCoreSuccessDialog(undefined));
      openURL(url, { newTab: true, isExternal: true });
    }
  };

  return (
    <>
      {isOpen && (
        <ChakraConfirmationDialog
          size="md"
          isOpen={isOpen}
          disableActions={loading}
          onClose={onClose}
          onCloseComplete={() => {
            dispatch(setTuneCoreSuccessDialog(undefined));
          }}
          handleAction={handleTuneCoreRedirect}
          title="Your TuneCore release is ready"
          message="Please visit TuneCore to complete your release and get it ready for distribution."
          hideCancelButton
          actionButtonText="Go to TuneCore"
        />
      )}
    </>
  );
};
